import { reactive, onBeforeMount, watch, computed } from '@vue/composition-api'
import { formatDate } from '@/util/common'
import { gtmLog } from '@/util/log'
import * as common from '@/util/common'
import * as apiCommon from '@/api/common'

export const KnowledgeDetail = (props, context) => {
  const { knowledgeId } = props
  const store = context.root.$store
  const { knowledge } = store.state

  const { knowledge: { detail } } = store.state
  // const { detail } = knowledge

  onBeforeMount(() => {
    store
      .dispatch('knowledge/getKnowledgeDetail', knowledgeId)
      .then(() => {
        state.initLoading = false

        // タイトル
        store.dispatch('common/addTitle', detail.title)

        // 印刷タイトルを設定
        store.dispatch('print/setTitle', detail.title)

        // 通常のログイン時のみGTMへログを送信する
        // （アカウントログインやフロントエンドログイン、書籍プレビューはSNH担当者による操作となるので実施しない）
        if (store.state.profile.login_type === 1) {
          // リロードでない
          const prevUrl = location.href
          const prevUrlComp = knowledge.prev_url
          store.dispatch('knowledge/setPrevUrlStr', prevUrl)
          if (knowledge.referrer.name !== null || prevUrl !== prevUrlComp) {
            store
              .dispatch('knowledge/getKnowledgeGA', knowledgeId)
              .then(() => {
                // GTMにログを送信する
                state.sendGtmLog(knowledgeId, knowledge.product_codes, detail)
              })
          }
        }
      })
  })

  watch(() => store.state.knowledge.detail.detail, (newVal, oldVal) => {

    let count = 0

    const timeId = setInterval(() => {

      if (typeof detail.knowledge_type === 'undefined') {
        return
      }

      if (detail.knowledge_type === 2) {
        // 「SHARES LAB」の場合

        const target = document.getElementById('shares-lab-footer-data')

        if (target) {
          const dateElement = document.getElementById('shares-lab-date')
          const outDateElement = document.getElementById('shares-lab-output-date')
          if (dateElement && outDateElement) {
            outDateElement.innerHTML = dateElement.innerHTML
          }
          
          const writerElement = document.getElementById('shares-lab-writer')
          const outWriterElement = document.getElementById('shares-lab-output-writer')
          if (writerElement && outWriterElement) {
            outWriterElement.innerHTML = writerElement.innerHTML
          }

          const contactElement = document.getElementById('shares-lab-contact')
          const outContactElement = document.getElementById('shares-lab-output-contact')
          if (contactElement && outContactElement) {
            outContactElement.innerHTML = contactElement.innerHTML
          }

          const writerAreaElement = document.getElementById('shares-lab-output')
          writerAreaElement.style.display = 'block'

          clearInterval(timeId)
        }
      } else if (detail.knowledge_type === 4) {
        // 「BUSINESS LAWYERS」の場合

        const htmlElement = document.getElementById('business-lawyers-footer-html')
        const outputHtmlElement = document.getElementById('business-lawyers-output-footer-html')

        if (htmlElement && outputHtmlElement) {
          outputHtmlElement.innerHTML = htmlElement.innerHTML
          outputHtmlElement.style.display = 'block'

          clearInterval(timeId)
        }
      }

      count++
      if (count > 60) {
        clearInterval(timeId)
      }
    }, 10)
  })

  const clickBookmark = async () => {
    if (detail.bookmarks_id === 0) {
      await store.dispatch('knowledge/setBookmark', knowledgeId)
      store.dispatch('common/showToast', { text: 'ブックマークに保存しました。' })
    } else {
      await store.dispatch('knowledge/removeBookmark', detail.bookmarks_id)
      store.dispatch('common/showToast', { text: 'ブックマークから削除しました。' })
    }
  }
  const clickSaveToNote = () => {
  }

  const clickKnowledgeDetail = event => {
    const target = event.target
    const tagName = target.tagName.toLowerCase()
    const hasParent = target.closest('.lc-auth-file-download')
    const className = target.className
    const classNames = className.split(' ')
    const isReplaced = target.dataset.replaced

    // 自信か親に対象クラスが含まれていれば、ファイルDL対象とする
    const isTargetTag = classNames.includes('lc-auth-file-download') || hasParent !== null

    if (tagName === 'a' && isTargetTag && !isReplaced) {
      const filePath = target.getAttribute('href')
      target.href = apiCommon.fetchKnowledfeAuthFile(filePath)
      target.dataset.replaced = '1'
    }
  }

  const state = reactive({
    visibleNoteSelect: false, // PC用： ノートポップアップ表示用のフラグ
    initLoading: true, // PC用
    visibleMenu: false, // SP用
    visibleSearchConditionEdit: false, // SP用
    visibleQADetailSelectNote: false, // SP用
    visibleNoteCreate: false, // SP用
    visibleNoteUserPermissionsEdit: computed(() => store.state.noteUserPermissionsEdit.isVisible), // SP用
    visibleBasicToastLator: false, // SP用
    visibleBasicToastSave: false, // SP用
    isActiveBookmark: false, // SP用

    /**
     * GTMにログを送信する
     */
    sendGtmLog: (knowledgeId, productCodes, detail) => {
      const productIdsStr = productCodes.join(',')

      // GTMパラメータ
      const extraParams = {
        'knowledge-cat': detail.medium_name,
        'knowledge-cat2': detail.medium_category,
        'knowledge-title': detail.title,
        'product-ids': productIdsStr
      }
      gtmLog('ga-knowledge-detail-user-log', extraParams)
    },

    /**
     * 著者名に設定するclass名
     */
    authorClass: computed(() => {
      if (detail.knowledge_type === 4) {
        // BUSINESS LAWYERS
        return 'author-biz-lawyers'
      } else {
        return 'author-default'
      }

    })
  })

  /**
   * サブタイトル(T&Amaster以外は執筆者が設定されている)のレイアウト
   * (文字列が複数行の場合の対応)
   * @param {*} subTitle 
   * @returns 
   */
  const layoutSubtitle = (subTitle) => {

    let newSubTitle = ''

    if (typeof subTitle !== 'undefined' && subTitle !== '') {
      const lines = subTitle.split(/\r?\n/)
      const newLines = []

      for (let i = 0; i < lines.length; i++) {
        const str = '<p>' + common.escapeHTML(lines[i]) + '</p>'
        newLines.push(str)
      }
      newSubTitle = newLines.join('')
    }

    return newSubTitle
  }

  const share = reactive({
    /**
     * 閲覧/編集権限付与設定ウィンドウを開く
     */
    openNoteUserPermissionsEdit: () => {
      store.dispatch('noteUserPermissionsEdit/show', 'select')
    },
    /**
     * 閲覧/編集権限付与設定ウィンドウを閉じる
     */
    hideNoteUserPermissionsEdit: () => {
      store.dispatch('noteUserPermissionsEdit/hide', 'select')
    }
  })

  return {
    state,
    detail,
    formatDate,
    clickBookmark,
    clickSaveToNote,
    clickKnowledgeDetail,
    layoutSubtitle,
    share
  }
}
